import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';

import services from 'core/services';
import GeneralModule from 'core/module';
import CategoryModule from 'core/states/Category';
import CartModule from 'content/pages/Cart/Module';
import OrderModule from 'content/pages/OrderStep/Module';

const NODE_ENV = process.env.NODE_ENV === 'development';

const reducer = {
  General: GeneralModule,
  Category: CategoryModule,
  Cart: CartModule,
  Order: OrderModule,
};

const extraArgs = [ services.ecommerce, services.http ];

export const store = NODE_ENV
  ? createStore(
      combineReducers(reducer),
      composeWithDevTools(applyMiddleware(thunkMiddleware.withExtraArgument(...extraArgs)))
    )
  : createStore(
      combineReducers(reducer),
      applyMiddleware(thunkMiddleware.withExtraArgument(...extraArgs))
    )

export default store;
